import App from "./App";
import { GTM_ID } from "./config/params";
import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: GTM_ID,
};

TagManager.initialize(tagManagerArgs);

export const ReactStrictMode = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

export const rootElement = document.getElementById("root");

ReactDOM.render(ReactStrictMode, rootElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
